import React from "react";
import Carousel from "@/components/ui/carousel/carousel";
import { SwiperSlide } from "swiper/react";
import { partners } from "@/data/partners";
import Image from "next/image";
import Section from "@/components/ui/section";
export default function Clients() {
  const data = [
    "/images/publications/ad.svg",
    "/images/publications/elle.svg",
    "/images/publications/foaid.svg",
    "/images/publications/houzz.svg",
    "/images/publications/design-essentials.svg",
    "/images/publications/gen2020.svg",
    "/images/publications/goodhomes.svg",
    "/images/publications/inda-today.svg",
  ];
  const breakpoints = {
    1280: {
      slidesPerView: 8,
      spaceBetween: 30,
      slidesOffsetBefore: 0,
      slidesOffsetAfter: 0,
    },
    991: {
      slidesPerView: 4.4,
      spaceBetween: 20,
      slidesOffsetBefore: 32,
      slidesOffsetAfter: 32,
    },
    // when window width is >= 768px
    768: {
      slidesPerView: 3.1,
      spaceBetween: 20,
      slidesOffsetBefore: 0,
      slidesOffsetAfter: 0,
    },
    325: {
      slidesPerView: 2.4,
      spaceBetween: 15,
      slidesOffsetBefore: 0,
      slidesOffsetAfter: 0,
    },
  };
  return (
    <div className="w-full flex flex-col lg:px-8 mt-16">
      <div className="border-darkGrey/50 border-b-[0.5px] lg:w-full mx-auto md:w-[calc(100vw-32px)] w-[calc(100vw-16px)] bg-transparent" />
      <div className="bg-[#F6F5F1] flex flex-col w-full py-20">
        <Carousel
          slidesPerView={8}
          spaceBetween={20}
          loop={false}
          className="featureCarousel w-full my-8"
          breakpoints={breakpoints}
          navigation={false}
          autoplay={{
            delay: 4500,
            disableOnInteraction: false,
          }}
          showNavAbove={false}
        >
          {data.map((partner, key) => (
            <SwiperSlide key={"feature" + key}>
              <div
                // target="_blank"
                // rel="noreferrer"
                className="w-full flex items-center justify-center"
              >
                <div className="relative md:w-[125px] md:h-[37px] w-full h-[30px]">
                  <Image
                    src={partner}
                    alt={"publication logo"}
                    sizes="(max-width: 479px) 500px, 500px"
                    fill
                    className="w-full h-full object-contain object-bottom"
                  />
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Carousel>
      </div>
    </div>
  );
}
